const flash = process.env.REACT_APP_NAME + "_flash" ;

export default flash ;